var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('PageHeader'),_c('div',{staticClass:"view-content"},[_c('keep-alive',{attrs:{"exclude":"Contact"}},[_c('router-view')],1),_c('PageFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }